export interface SummaryGenerationAttempt {
    id: string;
    action: 'generate';
    fileId: string;
    meetingType: string;
    taskId?: string;
    saved: boolean;
    /** Epoch ms of the POST; missing on attempts stored by older builds. */
    startedAt?: number;
    /** Terminal error the server reported; its task saves nothing afterwards. */
    serverError?: string;
}

const attempts = new Map<string, SummaryGenerationAttempt>();
const memoryOnly = new Set<string>();
const storageKey = (scope: string) => `notizy:web:summary-generation:${scope}`;

// Store only request identity, never preview text. A missing reservation after
// disconnect is not proof that the POST did not arrive.
export function readGenerationAttempt(scope: string): SummaryGenerationAttempt | null {
    if (memoryOnly.has(scope)) return attempts.get(scope) ?? null;
    try {
        const value = JSON.parse(localStorage.getItem(storageKey(scope)) || 'null');
        if (value?.action === 'generate' && typeof value.id === 'string' && typeof value.fileId === 'string'
            && typeof value.meetingType === 'string' && typeof value.saved === 'boolean') return value;
        return null;
    } catch { /* In-memory protection remains available if storage is unavailable. */ }
    return attempts.get(scope) ?? null;
}

export function writeGenerationAttempt(scope: string, attempt: SummaryGenerationAttempt | null) {
    if (attempt) attempts.set(scope, attempt);
    else attempts.delete(scope);
    try {
        if (attempt) localStorage.setItem(storageKey(scope), JSON.stringify(attempt));
        else localStorage.removeItem(storageKey(scope));
        memoryOnly.delete(scope);
    } catch { memoryOnly.add(scope); }
}
